<template>
  <div class="login-container">
    <!-- 装饰性背景元素 -->
    <div class="login-bg-decoration"></div>
    
    <!-- 登录卡片 -->
    <div class="login-card">
      <!-- 登录标题区 -->
      <div class="login-title">
        <h2>系统登录</h2>
        <p>欢迎回来，请登录您的账号</p>
      </div>

      <!-- 登录表单 -->
      <el-form
        ref="loginFormRef"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
      >
        <!-- 用户名输入框 -->
        <el-form-item prop="username" class="form-item">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名/手机号"
            prefix-icon="el-icon-user"
            clearable
            size="large"
            class="input-item"
          ></el-input>
        </el-form-item>

        <!-- 密码输入框 -->
        <el-form-item prop="password" class="form-item">
          <el-input
            v-model="loginForm.password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            :type="showPassword ? 'text' : 'password'"
            clearable
            size="large"
            class="input-item"
          >
            <i
              slot="suffix"
              :class="showPassword ? 'el-icon-view' : 'el-icon-hide'"
              @click="showPassword = !showPassword"
              class="password-icon"
            ></i>
          </el-input>
        </el-form-item>

        <!-- 登录按钮 -->
        <el-form-item class="btn-item">
          <el-button
            type="primary"
            class="login-btn"
            @click="handleLogin"
            :loading="loginLoading"
            size="large"
          >
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      // 登录表单数据
      loginForm: {
        username: '',
        password: ''
      },
      // 表单验证规则
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ],
      },
      // 密码显示/隐藏
      showPassword: false,
      // 登录加载状态
      loginLoading: false,
    }
  },
  methods: {
  // 处理登录
  handleLogin() {
    // 表单验证
    this.$refs.loginFormRef.validate(async (valid) => {
      if (!valid) return

      // 开启加载状态
      this.loginLoading = true

      console.log('登录', this.loginForm)
      try {
       
        const response = await this.$http.post('/apiLogin', this.loginForm);
        
        
        if (response.data.code === 200) { 
          this.$message.success('登录成功！')
        
          localStorage.setItem('isAuthenticated', response.data.token)
          this.$router.push('/form')
        } else {
          this.$message.warning(response.data.msg || '登录失败')
        }
      } catch (error) {
      
        this.$message.error(
          error.response?.data?.msg || '服务器错误，请重试'
        );
      } finally {
     
        this.loginLoading = false
      }
    })
  }
}
}
</script>
<style>
    #app {
    margin-top: 0 !important;
  }
  body {
    margin: 0 !important;
  }
</style>
<style scoped>

/* 全局登录容器 */
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
 
}

/* 背景装饰元素 */
.login-bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  z-index: 1;
}

/* 登录卡片 */
.login-card {
  width: 100%;
  max-width: 420px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 40px 30px;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.login-card:hover {
  box-shadow: 0 12px 40px rgba(31, 38, 135, 0.2);
  transform: translateY(-2px);
}

/* 登录标题 */
.login-title {
  text-align: center;
  margin-bottom: 30px;
}

.login-title h2 {
  font-size: 24px;
  color: #2d3748;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.login-title p {
  font-size: 14px;
  color: #718096;
  margin: 0;
}

/* 表单样式 */
.login-form {
  width: 100%;
}

/* 表单项 */
.form-item {
  margin-bottom: 20px;
}

/* 输入框样式 */
.input-item {
  border-radius: 10px;
  height: 50px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.input-item:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* 密码图标 */
.password-icon {
  font-size: 16px;
  color: #a0aec0;
  cursor: pointer;
  transition: color 0.2s ease;
}

.password-icon:hover {
  color: #667eea;
}

/* 验证码按钮样式 */
.code-btn {
  color: #667eea;
  font-size: 14px;
  padding: 0 10px;
  height: 100%;
  font-weight: 500;
}

.code-btn:disabled {
  color: #a0aec0;
  cursor: not-allowed;
}

/* 按钮容器 */
.btn-item {
  margin-top: 10px;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 50px;
  border-radius: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.login-btn:hover {
  background: linear-gradient(135deg, #5a6edb 0%, #6b4190 100%);
  transform: translateY(-1px);
}

.login-btn:active {
  transform: translateY(0);
}

/* 适配移动端 */
@media (max-width: 480px) {
  .login-container {
    padding: 10px;
  }
  .login-card {
    padding: 30px 20px;
  }

  .login-title h2 {
    font-size: 20px;
  }

  .input-item, .login-btn {
    height: 46px;
  }
  
  .code-btn {
    font-size: 13px;
  }
}

</style>